import React, { useEffect, useState } from "react";
import { utilService } from "../../../../services";
import sanitizeHtml from "sanitize-html";
import { EMSImageService } from "./EMSImageComponent.service";
import "./EMSImageComponent.scss";
import { dataTransferService } from "../../../../services/dataTransferService";
import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";

import {
  MediaCapture,
  MediaFile,
  CaptureImageOptions,
} from "@ionic-native/media-capture";

import { Capacitor } from "@capacitor/core";
import { File as ionicFile } from "@ionic-native/file";

declare const Recorder: any;
declare const MediaRecorder: any;

interface ImageComponentProps {
  onComplete: () => void;
  selectedDoctorData: object;
  isStatusBoard?: boolean;
  smsThread?: any;
  isFromEMS?: any;
}

const EMSImageComponent: React.FC<ImageComponentProps> = (props) => {
  const [mediaSource, setMediaSource]: any = useState();
  const [sourceBuffer, setSourceBuffer]: any = useState();
  const [mediaRecorder, setMediaRecorder]: any = useState();
  const [recordedBlobs, setRecordedBlobs]: any = useState();
  const [isWeb, setIsWeb]: any = useState(false);
  const [recordedVideo, setRecordedVideo]: any = useState({});
  const [isFromEMTStartACase, isSetFromEMTStartACase] = useState(false);

  useEffect(() => {
    if (utilService.isWeb()) {
      setIsWeb(true);
    }
  }, []);

  useEffect(() => {
    if (mediaSource) {
      if (utilService.isWeb()) {
        // mediaSource.addEventListener("sourceopen", handleSourceOpen, false);
        // const gumVideo = document.querySelector("video#gum");
        // setGumVideo(gumVideo);
        // setupVideoRecorder();
      }
    }
  }, [mediaSource]);

  useEffect(() => {
    if (isFromEMTStartACase) {
      startRecord();
    }
  }, [isFromEMTStartACase]);

  useEffect(() => {
    let sub = dataTransferService.getEMSImageMediaAction.subscribe(
      (data: any) => {
        if (data === true) {
          isSetFromEMTStartACase(false);
          startRecord();
        } else {
          stopRecord();
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  });

  useEffect(() => {
    let sub = dataTransferService.getEKGMediaAction.subscribe((data: any) => {
      if (data === true) {
        isSetFromEMTStartACase(true);
      } else {
        stopRecord();
      }
    });
    return () => {
      sub.unsubscribe();
    };
  });

  useEffect(() => {
    if (utilService.isWeb()) {
      const mediaSource = new MediaSource();
      setMediaSource(mediaSource);
    }
  }, []);

  const startRecord = () => {
    if (utilService.isWeb()) {
      //   webStartRecord();
    } else {
      nativeStartRecord();
    }
  };

  const stopRecord = () => {
    if (utilService.isWeb()) {
      //   webStopRecord();
    } else {
    }
  };

  const handleSourceOpen = () => {
    console.log("MediaSource opened");
    const sourceBuffer = mediaSource.addSourceBuffer(
      'video/webm; codecs="vp8"'
    );
    setSourceBuffer(sourceBuffer);
    console.log("Source buffer: ", sourceBuffer);
  };

  const setupVideoRecorder = () => {
    var options = { mimeType: "video/webm", bitsPerSecond: 100000 };
    setRecordedBlobs([]);

    var constraints = {
      audio: true,
      video: true,
    };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        (window as any).stream = stream; // make available to browser console
        const mediaRecorder = new MediaRecorder(
          (window as any).stream,
          options
        );
        setMediaRecorder(mediaRecorder);
        const gumVideo: any = document.querySelector("video#gum");
        // setGumVideo(gumVideo)
        // self.isRecorderSetuped = true;
        if ("srcObject" in gumVideo) {
          gumVideo.srcObject = stream;
        } else {
          // Avoid using this in new browsers, as it is going away.
          gumVideo.src = window.URL.createObjectURL(stream);
        }
        gumVideo.onloadedmetadata = function (e: any) {
          gumVideo.play();
        };
      })
      .catch(function (error) {
        console.log("navigator.getUserMedia error: ", error);
      });
  };

  const nativeStartRecord = async () => {
    let options: CaptureImageOptions = { limit: 1 };
    let capture: any = await MediaCapture.captureImage(options);
    if (capture.length > 0) {
      copyFileToLocalDir(capture[0].fullPath);
    }
    console.log((capture[0] as MediaFile).fullPath);
  };

  const copyFileToLocalDir = async (fullPath: any) => {
    const name = fullPath.substr(fullPath.lastIndexOf("/") + 1);
    let resolvedPath: any;
    let path = fullPath.substring(0, fullPath.lastIndexOf("/"));
    if (Capacitor.getPlatform() === "ios") {
      resolvedPath = await ionicFile.resolveDirectoryUrl("file://" + path);
    } else {
      resolvedPath = await ionicFile.resolveDirectoryUrl(path);
    }
    readAsArrayBuffer(resolvedPath, name);
  };

  const readAsArrayBuffer = (resolvedPath: any, name: any) => {
    return ionicFile.readAsArrayBuffer(resolvedPath.nativeURL, name).then(
      (buffer: any) => {
        const fileExtension = name.match(/\.[A-z0-9]+$/i)[0].slice(1);
        // get the buffer and make a blob to be saved
        let blob = new Blob([buffer], {
          type: `image/${fileExtension}`,
        });
        setFileData(blob, resolvedPath.nativeURL, name, fileExtension);
      },
      (error: any) => console.log(error)
    );
  };

  const setFileData = (Blob: any, path: any, name: any, extn: any) => {
    const fileData = blobToFile(Blob, name);
    const filePath = path + name;
    if (isFromEMTStartACase) {
      setEMSNativeParams(fileData, filePath, extn);
      isSetFromEMTStartACase(false);
    } else {
      setNativeParams(fileData, filePath, extn);
    }
  };

  const webStartRecord = () => {
    // this.isRecordingStopped = false;
    setRecordedBlobs([]);
    mediaRecorder.onstop = (event: any) => {
      //
    };
    mediaRecorder.ondataavailable = (event: any) => {
      recordedBlobs.push(event.data);
      setRecordedBlobs(recordedBlobs);
    };
    mediaRecorder.start(10); // collect 10ms of data
    // this.isRecordingStarted = true;
    console.log("MediaRecorder started", mediaRecorder);
  };


  const play = () => {
    var type = (recordedBlobs[0] || {}).type;
    var superBuffer = new Blob(recordedBlobs, { type });
    var url = URL.createObjectURL(superBuffer);
    const sanitizedUrl = sanitizeHtml(url);

    const recordedVideo = {
      name: "VID-" + new Date().getMinutes() + new Date().getSeconds(),
      type: 3,
      nativeURL: sanitizedUrl,
      size: utilService.formatBytes(superBuffer.size),
    };
    setRecordedVideo(recordedVideo);
    const fileData = blobToFile(superBuffer, "vid");
    if (isFromEMTStartACase) {
      setEMSWebParams(fileData, recordedVideo);
      isSetFromEMTStartACase(false);
    } else {
      setWebParams(fileData, recordedVideo);
    }
    // this.isRecordingStarted = false;
  };

  const blobToFile = (theBlob: any, fileName: string): any => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;
    // b.__proto__ = File.prototype;

    //Cast to a File() type
    return theBlob as any;
  };

  const mapToGuidData = () => {
    if (props.isStatusBoard) {
      var initialArray = [];
      initialArray.push(utilService.getLoggedUserGuid());
      return JSON.stringify(initialArray);
    } else {
      return JSON.stringify(
        doctorsListService.getSelectedUsersList(props.selectedDoctorData)
      );
    }
  };

  const setEMSNativeParams = (fileData: any, filePath: any, extn: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    const serverParams = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      type: 5,
      action: 1,
      name: filePath.substr(filePath.lastIndexOf("/") + 1),
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    const localParams = {
      clientMediaID: clientMediaID,
      type: 5,
      name: filePath.substr(filePath.lastIndexOf("/") + 1),
      nativeURL: filePath,
      size: utilService.formatBytes(fileData.size),
    };
    EMSImageService.EKGDisplayImageList.push(localParams);
    EMSImageService.EKGUploadImageList.push(serverParams);
    props.onComplete();
  };

  const setEMSWebParams = (fileData: any, recordedVideo: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    recordedVideo.clientMediaID = clientMediaID;
    const params = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      type: 5,
      action: 1,
      name:
        "VID-" + new Date().getMinutes() + new Date().getSeconds() + ".webm",
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    EMSImageService.EKGDisplayImageList.push(recordedVideo);
    EMSImageService.EKGUploadImageList.push(params);
    props.onComplete();
  };

  const setWebParams = (fileData: any, recordedVideo: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    recordedVideo.clientMediaID = clientMediaID;
    const params = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 1,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      name:
        "VID-" + new Date().getMinutes() + new Date().getSeconds() + ".webm",
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    EMSImageService.displayEMSImageList.push(recordedVideo);
    EMSImageService.uploadEMSImageList.push(params);
    props.onComplete();
  };

  const setNativeParams = (fileData: any, filePath: any, extn: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    const serverParams = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 1,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      name: filePath.substr(filePath.lastIndexOf("/") + 1),
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    const localParams = {
      clientMediaID: clientMediaID,
      type: 1,
      name: filePath.substr(filePath.lastIndexOf("/") + 1),
      nativeURL: filePath,
      size: utilService.formatBytes(fileData.size),
    };
    EMSImageService.displayEMSImageList.push(localParams);
    EMSImageService.uploadEMSImageList.push(serverParams);
    props.onComplete();
  };

  return (
    <div className="video-comp-container">
      {/* {isWeb && (
        <div className="live-cam-div">
          <video id="gum" playsInline></video>
        </div>
      )} */}
    </div>
  );
};

export default EMSImageComponent;
